// extracted by mini-css-extract-plugin
export var container = "_di-0";
export var outlet = "_di-1";
export var outletEnter = "_di-2";
export var outletEnterActive = "_di-3";
export var outletExit = "_di-4";
export var outletExitActive = "_di-5";